<template>
  <div style="min-width: 80%">
    <h1 class="grey--text text--darken-2">{{ isNaN(this.$route.params.id) ? 'Новая компания' : 'Редактирование компании' }}<span v-if="form.companyIsDA" class="cyan--text ml-3">[DA]</span></h1>

    <v-form>
      <v-text-field
        v-model.trim="form.companyName"
        autofocus
        prepend-icon="mdi-factory"
        hint="Наименование"
        persistent-hint
        :error-messages="verrCompanyName"
        @input="$v.form.companyName.$touch()"
        @blur="$v.form.companyName.$touch()"/>

      <v-row>
        <v-col class="py-0">
          <v-text-field
            v-model.trim="form.companyLyric"
            prepend-icon="mdi-text-short"
            hint="Лирическое название"
            persistent-hint/>
        </v-col>
        <v-col class="py-0">
          <v-select
            v-model="form.companyKopfg"
            :items="kopfg"
            prepend-icon="mdi-format-list-bulleted-type"
            persistent-hint
            hint="Форма хозяйствования"
            clearable/>
        </v-col>
      </v-row>

      <v-row class="py-0">
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model.trim="form.company_edrpou"
            prepend-icon="mdi-barcode"
            hint="Код ЕДРПОУ"
            persistent-hint
            :error-messages="verr_company_edrpou"
            @input="$v.form.company_edrpou.$touch()"
            @blur="$v.form.company_edrpou.$touch()"/>
        </v-col>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model.trim="form.company_ipn"
            prepend-icon="mdi-barcode"
            hint="Индивидуальный налоговый номер"
            persistent-hint
            :error-messages="verr_company_ipn"
            @input="$v.form.company_ipn.$touch()"
            @blur="$v.form.company_ipn.$touch()"/>
        </v-col>
        <v-col cols="6" class="py-0">
          <v-text-field
            v-model.trim="form.companyIBAN"
            prepend-icon="mdi-bank"
            hint="IBAN"
            persistent-hint
            :error-messages="verrCompanyIBAN"
            @input="$v.form.companyIBAN.$touch()"
            @blur="$v.form.companyIBAN.$touch()"/>
        </v-col>
      </v-row>

      <v-text-field
        v-model.trim="form.companyAddress"
        prepend-icon="mdi-home-city"
        hint="Юридический адрес"
        persistent-hint/>

      <v-text-field
        v-model.trim="form.companyMail"
        prepend-icon="mdi-mail"
        hint="Адрес для переписки"
        persistent-hint/>

      <div class="caption ml-1 mt-5 grey--text text--darken-3">Дополнительная информация</div>
      <vue-editor v-model="form.companyInfo" class="mt-1"/>

      <div v-if="contacts.length" class="caption ml-1 mt-5 grey--text text--darken-3">Сотрудники</div>
       <v-list two-line>
          <template v-for="(item, index) in contacts">
            <v-divider v-if="index" :key="'divider'+index" :inset="true"></v-divider>
            <v-list-item :key="item.title">
              <v-list-item-avatar>
                <v-icon x-large>mdi-account-circle</v-icon>
                <!-- <v-img src="https://cdn.vuetifyjs.com/images/lists/1.jpg"></v-img> -->
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>
                  {{ item.contactFName }} {{ item.contactMName }} {{ item.contactLName }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ item.staffDept }} {{ item.staffPost }}</v-list-item-subtitle>
                <v-list-item-subtitle>
                  {{ item.contactPhone }}<span v-if="item.contactPhone && item.contactEmail" class="mr-2">,</span>
                  <a :href="'mailto:'+item.contactEmail" v-html="item.contactEmail"></a>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>

      <v-divider class="mt-3"/>
      <v-card-actions class="mt-1">
        <v-btn
          raised
          @click="cancelAction" class="mr-3">Отмена</v-btn>
        <v-btn
          raised
          color="primary"
          :loading="loading"
          :disabled="$v.$invalid"
          @click="submitAction">Сохранить</v-btn>
      </v-card-actions>
    </v-form>

  </div>
</template>

<script>
import api from '@/api'
import { VueEditor } from "vue2-editor";
import { validationMixin } from 'vuelidate'
import { required, numeric, minLength, helpers } from 'vuelidate/lib/validators'
import { validate as validate_edrpou } from '@/validate-edrpou'

const validIBAN = (iban) => {
  if ( typeof iban === 'undefined' || iban == '' ) return true
  const iban_stripped = iban.replace(/[^A-Z0-9]+/gi, '').toUpperCase()
  const m = iban_stripped.match(/^([A-Z]{2})([0-9]{2})([A-Z0-9]{9,30})$/)
  if ( !m ) return false
  const numbericed = (m[3] + m[1] + m[2]).replace(/[A-Z]/g, ch => (ch.charCodeAt(0)-55))
  const mod97 = numbericed.match(/\d{1,7}/g).reduce((total, curr) => (Number(total + curr)%97), '')
  return (mod97 === 1)
}

const validEDRPOU = (code) => {
  if ( typeof code === 'undefined' || code == '' ) return true
  return validate_edrpou(code)
}

export default {
  mixins: [ validationMixin ],
  components: { VueEditor },
  data: () => ({
    loading: false,
    kopfg: [],
    form: {},
    contacts: [],
  }),
  validations: {
    form: {
      companyName: { required, minLength: minLength(3) },
      companyIBAN: { validIBAN },
      company_edrpou: { numeric },
      company_ipn: { numeric }
    }
  },
  computed: {
    verrCompanyName () {
      return !this.$v.form.companyName.$dirty ? [] :
        !this.$v.form.companyName.minLength ? 'Минимум 3 символа' :
        !this.$v.form.companyName.required ? 'Введите наименование' : []
    },
    verrCompanyIBAN () {
      return !this.$v.form.companyIBAN.$dirty ? [] :
        !this.$v.form.companyIBAN.validIBAN ? 'Невалидный IBAN' : []
    },
    verr_company_edrpou () {
      return !this.$v.form.company_edrpou.$dirty ? [] :
        !this.$v.form.company_edrpou.numeric ? 'Только цифры' : []
    },
    verr_company_ipn () {
      return !this.$v.form.company_ipn.$dirty ? [] :
        !this.$v.form.company_ipn.numeric ? 'Только цифры' : []
    }
  },
  mounted: function () {
    isNaN(this.$route.params.id) ? this.loadKopfg() : this.load()
  },
  methods: {
    load () {
      this.loading = true
      api.get('companies/get/'+this.$route.params.id).then(response => {
        this.loading = false;
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.form = response.data.data.company
        this.contacts = response.data.data.contacts
        this.kopfg = response.data.data.kopfg.map(i => (i[1] ? { text: i[2] + (i[3] ? ' ('+i[3]+')' : ''), value: i[0]} : { header: i[2] }))
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    loadKopfg () {
      this.loading = true
      api.get('companies/kopfg').then(response => {
        this.loading = false;
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.kopfg = response.data.data.kopfg.map(i => (i[1] ? { text: i[2] + (i[3] ? ' ('+i[3]+')' : ''), value: i[0]} : { header: i[2] }))
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    cancelAction () {
      this.$router.go(-1)
    },
    submitAction () {
      if ( this.$v.$error ) return
      this.loading = true
      let action = this.form.companyID ? 'update/'+this.$route.params.id : 'create';
      api.post('companies/'+action, this.form).then(response => {
        this.loading = false;
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        if ( response.data.data.affected ) this.$root.$alert('Компания сохранена')
        this.$router.go(-1)
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  }
}
</script>

<style>
.v-list-item { min-height: 30px }
.v-list-item__content { padding: 0; }
.v-list-item__title { font-size: 0.92rem; }

.v-subheader { height: 30px; padding-left: 8px; letter-spacing: 2px; margin-top: 4px; }
</style>
